import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Messages } from '../../constants/messages';
import { emptyDummyResponse, emptyStudent } from '../../constants/prepareEmptyObject';
import { ApiResult } from 'src/app/shared/model/apiresult';
import { IDummyResponse, IStudent } from '../../model/student';
import { LookupService } from 'src/app/modules/maintenance/services/lookup.service';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { Guid } from 'guid-typescript';
import { StudentAthleteService } from '../../services/student-athlete.service';
import { ILookup } from 'src/app/shared/model/Index';
import { ELookup } from '../../constants/eLookup';
import { ActivatedRoute, Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmationDialog } from '../../component/confirmation-dialog.component';

const moment = _rollupMoment || _moment;

@Component({
    selector: 'student-athlete',
    templateUrl: './student-athlete.component.html'
})
export class StudentAthleteComponent implements OnInit {
    public student: IStudent = emptyStudent();
    public dummyResponse: IDummyResponse = emptyDummyResponse();

    @Input() selectedStudent: IStudent;
    @Input() WriteAction:boolean=false;
    public sexList: ILookup[];
    public residenceList: ILookup[];
    public reasonsList: ILookup[];
    public majorDisciplineList: ILookup[];
    public institutionTermList: ILookup[];
    public institutionTermListFall: ILookup[];
    public institutionTermListFallSpring: ILookup[];
    public institutionTermListFallSpringQuarter: ILookup[];
    public collegeList: ILookup[];
    mask = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

    public studentFormGroup: UntypedFormGroup;
    currentDate = new Date();
    minDate = new Date(1900, 1, 1);
    studentID: Guid;
    institutionId:string;
    constructor(
        private _snackBar: MatSnackBar,
        private _formBuilder: UntypedFormBuilder,
        private _lookupservice: LookupService,
        private _studentathleteservice: StudentAthleteService,
        private _route: ActivatedRoute,
        private router: Router,
        private dialog: MatDialog) {
        //Form Group Initiation.
        this.fillForm(this.student);
    }
    ngOnInit() {
        this._route.queryParams.subscribe(params => {
            this.studentID = params.id;
            this.institutionId=params.institutionId;
        });
        this.getActiveLookups(ELookup.Sex);
        this.getActiveLookups(ELookup.Residence);
        this.getActiveLookups(ELookup.Reason);
        this.getActiveLookups(ELookup.MajorDiscipline);
        this.getActiveLookups(ELookup.InstitutionTerm);
        this.getActiveLookups(ELookup.College);
        if (this.studentID != null) {
            this.get(this.studentID);
        }
        if(this.institutionId != null)
        {
            this.getStudentInfoByLsuId(this.institutionId);
        }
        else
        {
            this.studentFormGroup.controls['institutionId'].disable();
        }
    }

    cancel() {
        this.router.navigate(['/student-search']);
    }

    private getActiveLookups(tableName: string) {
        this._lookupservice.getActiveLookups(tableName).subscribe((result: ApiResult<ILookup[]>) => {
            if (result.validationErrors == null) {
                switch (tableName) {
                    case ELookup.InstitutionTerm:
                        this.institutionTermList = result.value;
                        this.institutionTermListFall = result.value.filter(t => (t.code.indexOf('1S') >= 0));
                        this.institutionTermListFallSpring = result.value.filter(t => (t.code.indexOf('1S') >= 0 || t.code.indexOf('2S') >= 0));
                        this.institutionTermListFallSpringQuarter = result.value.filter(t => (t.code.indexOf('1S') >= 0 || t.code.indexOf('2S') >= 0 || t.code.indexOf('Q') >= 0));
                        break;
                    case ELookup.Sex:
                        this.sexList = result.value;
                        break;
                    case ELookup.Residence:
                        this.residenceList = result.value;
                        break;
                    case ELookup.Reason:
                        this.reasonsList = result.value;
                        break;
                    case ELookup.MajorDiscipline:
                        this.majorDisciplineList = result.value;
                        break;
                    case ELookup.College:
                        this.collegeList = result.value;
                        break;
                    default:
                        break;
                }
            }
        }, error => console.error(error));
    }
    public onSelectFirstTermChange(event: any) {
        let year = this.institutionTermList.filter(t => t.id === event.value)[0].code.substring(0,4);
        let term = this.institutionTermList.filter(t => t.id === event.value)[0].code.substring(4,6);

        // fix term for quarter schools
        if(term == '1Q' || term == '4Q')
        {
            term = '1S'
        }
        else if(term == '2Q' || term == '3Q')
        {
            term = '2S';
        }

        let declareMajorTermYear = parseInt(year) + 2;
        let declareMajorTermCode = declareMajorTermYear.toString().concat(term);
        let declareMajorTermId = this.institutionTermList.filter(t => t.code === declareMajorTermCode)[0].id;

        this.studentFormGroup.get('declaredMajorTermId').setValue(declareMajorTermId);
    }
    private get(id: Guid) {
        this._studentathleteservice.get(id).subscribe((result: ApiResult<IStudent>) => {
            if (result.validationErrors == null && result.value != null) {
                this.student = result.value;
                this.fillForm(this.student)
            }
        }, error => console.error(error));
    }
    private getStudentInfoByLsuId(lsuID: string) {
        this._studentathleteservice.getStudentInfoByLsuId(lsuID).subscribe((result: ApiResult<IStudent>) => {
            if (result.validationErrors == null && result.value != null) {
                this.student = result.value;
                this.student.studentId = null;
                this.student.isAddStudentByLsuId=true;
                this.fillForm(this.student);
                this.studentFormGroup.controls['institutionId'].disable();
                this.studentFormGroup.controls['workdayId'].disable();
                this.studentFormGroup.controls['slateId'].disable();
                this.studentFormGroup.controls['academicRecordReferenceId'].disable();
                //this.studentFormGroup.get('person').get('lastName').disable();
                //this.studentFormGroup.get('person').get('firstName').disable();
                //this.studentFormGroup.get('person').get('middleName').disable();
                //this.studentFormGroup.get('person').get('birthDate').disable();
            }
        }, error => console.error(error));
    }
    private fillForm(studentInfo: IStudent) {
        this.studentFormGroup = this._formBuilder.group(
            {
                studentId: [studentInfo.studentId],
                personId: [studentInfo.personId],
                tenantId: [studentInfo.tenantId],
                institutionId: [studentInfo.institutionId],
                workdayId: [studentInfo.workdayId],
                slateId: [studentInfo.slateId],
                academicRecordReferenceId: [studentInfo.academicRecordReferenceId],
                person: this._formBuilder.group({
                    lastName: [studentInfo.person.lastName],
                    firstName: [studentInfo.person.firstName],
                    middleName: [studentInfo.person.middleName],
                    suffix: [studentInfo.person.suffix],
                    birthDate: [studentInfo.person.birthDate],
                    sexId: [studentInfo.person.sexId],
                    ncaaid: [studentInfo.person.ncaaid],
                    ssn: [studentInfo.person.ssn],
                    email: [studentInfo.person.email],
                }),
                hasRecruitment: [studentInfo.hasRecruitment],
                hasScholarship: [studentInfo.hasScholarship],
                hasImmunization: [studentInfo.hasImmunization],
                residenceId: [studentInfo.residenceId],
                initialInstitutionTermId: [studentInfo.initialInstitutionTermId],
                initialTenantTermId: [studentInfo.initialTenantTermId],
                finalTenantTermId: [studentInfo.finalTenantTermId],
                fullTimeTransferTerms: [studentInfo.fullTimeTransferTerms],
                withdrawalReasonId: [studentInfo.withdrawalReasonId],
                nineHourWaiverTermId: [studentInfo.nineHourWaiverTermId],
                declaredMajorTermId: [studentInfo.declaredMajorTermId],
                intendedMajorId: [studentInfo.intendedMajorId],
                intendedMajorDate: [studentInfo.intendedMajorDate],
                isAddStudentByLsuId:[studentInfo.isAddStudentByLsuId],
            });

            this._route.queryParams.subscribe(params => {                
                if(params.id!=null){
                    this.studentFormGroup.disable();
                }
            });
           
    }
    public editForm() {
        this.studentFormGroup.enable();
        this.studentFormGroup.controls['institutionId'].disable();
        this.studentFormGroup.controls['workdayId'].disable();
        this.studentFormGroup.controls['slateId'].disable();
        this.studentFormGroup.controls['academicRecordReferenceId'].disable();
        //this.studentFormGroup.get('person').get('lastName').disable();
        //this.studentFormGroup.get('person').get('firstName').disable();
        //this.studentFormGroup.get('person').get('middleName').disable();     
        //this.studentFormGroup.controls['hasImmunization'].disable();
    }  
    public onSubmit() {
        this.student = this.studentFormGroup.value as IStudent;
        this.student.person.tenantId = this.student.tenantId;
        this.student.person.personId = this.student.personId;
        this.student.academicRecordReferenceId = this.studentFormGroup.controls['academicRecordReferenceId'].value;
        this.student.hasImmunization = this.studentFormGroup.controls['hasImmunization'].value;

        if (this.student.studentId !== null) {
            this._studentathleteservice.put(this.student).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.notify(Messages.StudentAthleteSaved);
                }
                else {
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
        else {
            this.student.studentId = Guid.createEmpty().toJSON().value;
            this.student.tenantId = Guid.createEmpty().toJSON().value;
            this.student.personId = Guid.createEmpty().toJSON().value;

            this.student.person.tenantId = this.student.tenantId;
            this.student.person.personId = this.student.personId;
            if(this.student.isAddStudentByLsuId)
            {
                this.student.institutionId=this.institutionId;
            }
            this._studentathleteservice.post(this.student).subscribe((result: ApiResult<Guid>) => {
                if (result.statusCode == 200) {
                    this.notify(Messages.StudentAthleteSaved);
                    this.router.navigate(['/compliance', ''], { queryParams: {id: result.value}});
                }
                else {
                    this.student.studentId = null;
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
    }
    notifyWarnings(message: string[]) {
        let snackBarRef = this._snackBar.open(message[0], "Close", {
            duration: 5000,
            panelClass: ['red-snackbar']
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }
    notify(message: string) {
        let snackBarRef = this._snackBar.open(message, "Close", {
            duration: 2000,
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }

    evalBind(data:ILookup,currentValue:number){
        if(data.id==currentValue){
            return true;
        }
      return !data.disabled;
    }
}
